import { defineStore } from 'pinia';
import { useMilkomedaWSCBridge } from '@/composables/milkomeda-wrapped-smartcontract/useMilkomedaWSCBridge';

export const useSwapMilkomedaWSCBridge = defineStore('swapMilkomedaWSCBridge', () => {
  const milkomedaWSCBridge = useMilkomedaWSCBridge();

  return {
    ...milkomedaWSCBridge,
  };
});
